import axios from "axios";

const API_URL =
  "https://zc81ciqz81.execute-api.eu-central-1.amazonaws.com/demo"; // TODO: .env

/**
 * Create a new Axios client instance
 * @see https://github.com/axios/axios#creating-an-instance
 */
const getClient = (endpoint = "") => {
  const options = {
    baseURL: `${API_URL}/${endpoint}/`
  };

  const client = axios.create(options);

  client.interceptors.request.use(
    requestConfig => requestConfig,
    requestError => {
      return Promise.reject(requestError);
    }
  );

  client.interceptors.response.use(
    response => response,
    error => {
      return Promise.reject(error);
    }
  );

  return client;
};

class ApiClient {
  constructor(endpoint = "") {
    this.client = getClient(endpoint);
  }

  get(id, conf = {}) {
    return this.client
      .get(id, conf)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error));
  }

  delete(id, conf = {}) {
    return this.client
      .delete(id, conf)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error));
  }

  post(data = {}, conf = {}) {
    return this.client
      .post("", data, conf)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error));
  }

  put(id, data = {}, conf = {}) {
    return this.client
      .put(id, data, conf)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error));
  }

  patch(id, data = {}, conf = {}) {
    return this.client
      .patch(`${id.toString()}/`, data, conf) // TODO: clean this mess
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error));
  }
}

export { ApiClient };

const getBaseClient = (endpoint = "") => {
  const options = {
    baseURL: `${API_URL}/${endpoint}`
  };

  return axios.create(options);
};
/**
 * Base HTTP Client
 */
export default {
  // Provide request methods with the default base_url and without interceptors
  get(url, conf = {}) {
    return getBaseClient()
      .get(url, conf)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error));
  },

  delete(url, conf = {}) {
    return getBaseClient()
      .delete(url, conf)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error));
  },

  post(url, data = {}, conf = {}) {
    return getBaseClient()
      .post(url, data, conf)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error));
  },

  put(url, data = {}, conf = {}) {
    return getBaseClient()
      .put(url, data, conf)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error));
  },

  patch(url, data = {}, conf = {}) {
    return getBaseClient()
      .patch(url, data, conf)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error));
  }
};
